import { Injectable, Inject } from "@angular/core";
import { HttpService, URI } from "../shared/http.service";
import { HttpHeaders } from "@angular/common/http";

@Injectable()
export class ArticleHttpService {
  constructor(private httpService: HttpService) { }
  
  public getById(id: number) {
    return this.httpService.get<string>(URI`/api/article/${id}`);
  }
  
  public getItems(text: string) {
    return this.httpService.post<string[]>(URI`/api/article/items`, null, { text });
  }
}